import { h } from 'preact';
import ResolveOption from '../ResolveOption';
import PageWrapper from '../PageWrapper';
import { AssistContent, AssistButtonAction, AssistButtonDeferredAction, AssistRenderType } from '../../types';
import { CloseIcon } from '../Icons';
import { memo } from 'preact/compat';
import './styles.scss';

interface Props {
  onHideModal: () => void;
  onNextStep: ({
    action,
    deferredAction,
    renderType,
  }: {
    action: AssistButtonAction;
    deferredAction: AssistButtonDeferredAction;
    renderType: AssistRenderType;
  }) => void;
  content: AssistContent;
  renderType: AssistRenderType;
  lang: string;
}

function HelpStep({ onHideModal, onNextStep, content, renderType }: Props) {
  return (
    <PageWrapper>
      <div className="modal-header_ta">
        <h1 className="help-step__title">{content.title}</h1>
        <CloseIcon className="close-button_ta" size={14} onClick={onHideModal} />
      </div>
      <div className="modal-body_ta">
        <h2 className="help-step__subtitle">{content.subtitle}</h2>
        <div className="resolve-options-list">
          {content.buttons.map(({ label, context, action, deferred_action }, i) => (
            <ResolveOption
              key={i}
              title={label}
              description={context}
              onPress={() => onNextStep({ action, deferredAction: deferred_action, renderType })}
            />
          ))}
        </div>
      </div>
    </PageWrapper>
  );
}

export default memo(HelpStep);
